import React, { useState, useEffect, useMemo } from 'react'
import Grid from '@mui/material/Grid2'
import { Button, Box, Typography, Divider, colors } from '@mui/material'
import { styled } from '@mui/material/styles'
import Stack from '@mui/material/Stack'

import Checkbox from '@mui/material/Checkbox'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import TablePagination from '@mui/material/TablePagination'
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table'
import Api from '../../Api/Api'
import Loader from '../../Components/Loading'

//nested data is ok, see accessorKeys in ColumnDef below
const data = [
  {
    name: {
      firstName: 'Zachary',
      lastName: 'Davis',
    },
    address: '261 Battle Ford',
    city: 'Columbus',
    state: 'Ohio',
  },
  {
    name: {
      firstName: 'Robert',
      lastName: 'Smith',
    },
    address: '566 Brakus Inlet',
    city: 'Westerville',
    state: 'West Virginia',
  },
  {
    name: {
      firstName: 'Kevin',
      lastName: 'Yan',
    },
    address: '7777 Kuhic Knoll',
    city: 'South Linda',
    state: 'West Virginia',
  },
  {
    name: {
      firstName: 'John',
      lastName: 'Upton',
    },
    address: '722 Emie Stream',
    city: 'Huntington',
    state: 'Washington',
  },
  {
    name: {
      firstName: 'Nathan',
      lastName: 'Harris',
    },
    address: '1 Kuhic Knoll',
    city: 'Ohiowa',
    state: 'Nebraska',
  },
]

const styles1 = {
  grid1: {
    padding: 4,
    background: '#2C2D33',
    borderRadius: '10px',
    border: '1px solid #afafaf',
    borderImageSlice: 1,
    borderImage:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  Typography1: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: '28.96px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography2: {
    color: '#D2D2D2',
    fontFamily: 'Noto Sans KR',
    fontSize: '19px',
    fontWeight: 700,
    lineHeight: '18.82px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography3: {
    color: '#D2D2D2',
    fontFamily: 'Noto Sans KR',
    fontSize: '15px',
    fontWeight: 300,
    lineHeight: '15.82px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  TableCell1: {
    color: '#CCCCCC',
    borderBottom: '1px solid #CCCCCC',
    background:
      'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
  },
  TableCellHeader1: { background: '#2F2E41', color: '#ffffff', borderBottom: '1px solid #CCCCCC' },
}
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein }
}

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
]

export default function WorkerIN() {
  const [pg, setpg] = React.useState(0)
  const [rpg, setrpg] = React.useState(5)
  const [JobList, setJobList] = useState([])
  const [loadingFlag, setLoadingFlag] = useState(false)

  function handleChangePage(event, newpage) {
    setpg(newpage)
  }
  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10))
    setpg(0)
  }
  const [checkValue, setCheckValue] = React.useState(true)

  const [rowSelection, setRowSelection] = React.useState({})
  React.useEffect(() => {
    //do something when the row selection changes...
    console.info({ rowSelection })
  }, [rowSelection])

  React.useEffect(() => {
    jobListFun()
  }, [])

  const handleCheckChange = (event) => {
    setCheckValue(event.target.checked)
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: 'jn',
        header: '작업명',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'wkl',
        Cell: ({ cell }) =>
          cell
            .getValue()
            ?.map((item, index) =>
              cell.getValue().length - 1 === index ? `${item.workerName}` : `${item.workerName}, `
            ),
        header: '작업근로자',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'sdt',
        header: '작업시작시간',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'edt',
        header: '작업종료시간',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )

  const table = useMantineReactTable({
    columns: columns,
    data: JobList, //must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    getRowId: (row) => row.ji,
    onRowSelectionChange: setRowSelection,
    state: { rowSelection },
    selectDisplayMode: 'checkbox',
    enableRowSelection: true,
    enableMultiRowSelection: true,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: true,
    enableSorting: false,
    enableFullScreenToggle:false,
    paginationDisplayMode:"pages",
    mantineTableHeadCellProps: {
      sx: { background: '#2F2E41' },
      align: 'start',
      // '.mantine-TableHeadCell-Content-Wrapper': {
      //   color: '#ffffff',
      // },
      ' .mantine-TableHeadCell-Content-Labels .mantine-TableHeadCell-Content-Wrapper': {
        color: '#ffffff',
      },
    },
    mantineTableBodyCellProps: {
      sx: {
        color: '#CCCCCC',
        background:
          'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
      align: 'start',
    },
    mantineDetailPanelProps: {
      sx: {
        color: '#ffffff',
        background:
          'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
    },
    mantineTopToolbarProps: {
      sx: {
        color: '#ffffff',
        background: '#21222D',
        // mantine-Stack-root
        '.mantine-Alert-root': {
          color: '#ffffff',
          background: '#21222D',
        },
        '.mantine-Stack-root': {
          color: '#ffffff',
          background: '#21222D',
        },
      },
    },
    mantineBottomToolbarProps: {
      sx: {
        background: '#21222D',
        '.mantine-Input-input': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '.mantine-InputWrapper-label': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '& .mantine-Text-root': {
          color: '#ffffff',
        },
      },
    },
    mantinePaginationProps: {
      sx: {
        background: '#21222D',
        '.mantine-UnstyledButton-root': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
      },
    },
  })

  const jobListFun = async () => {
    setLoadingFlag(true)
    try {
      // const response = await Api.get('api/v1/job')
      const response = await Api.get('/api/v1/job/get_job_lists/works')

      let copyState = []
      if (response.status === 200) {
        setJobList(response.data)
        copyState = response.data
        setLoadingFlag(false)
      }
      console.log('jobListFun response.data', response.data)
      console.log('jobListFun JobList', JobList)
      console.log('jobListFun copyState', copyState)
    } catch (e) {
      setLoadingFlag(false)
      console.log('jobListFun exception', e)
    }
  }

  const workOut = async () => {
    let arr = Object.keys(rowSelection)
    let result_list = []
    if (arr.length > 0) {
      arr.map((item) => {
        const find1 = JobList.findIndex((element, index, array) => {
          return element.ji === item
        })
        if (JobList[find1].wkl.length <= 0) {
          alert(`${JobList[find1].jn} 작업에 등록된 근로자가 없습니다`)
        } else {
          result_list.push(item)
        }
      })
      if (result_list.length > 0) {
        console.log('workOut result_list:', result_list)
        try {
          const response = await Api.post(`/api/v1/job/update_wkl_out_job/endt`, result_list)
          if (response.status === 200) {
            setRowSelection({})
            jobListFun()
            alert('작업철수 성공')
          }
          if (response.status === 403) {
            alert('이미 작업철수 등록한 근로자가 있습니다.')
          }
          console.log('workOut response.data1:', response.data)
        } catch (e) {
          if (e.status === 403) {
            alert('이미 작업철수 등록한 근로자가 있습니다.')
          } else {
            alert(`작업철수 실패 ${e}`)
          }

          console.log('workOut exception', e)
        }
      }
    } else {
      alert('선택된 작업이 없습니다.')
    }
  }
  return (
    <div style={{ padding: 17 }}>
      <Grid container sx={{ marginLeft: 3, marginRight: 3 }}>
        <Grid size={12} sx={styles1.grid1}>
          <Grid container>
            <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Typography sx={[styles1.Typography1]}>근로자 작업 철수 신청</Typography>
            </Grid>
            <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Typography sx={[styles1.Typography2, { marginTop: 1, marginLeft: 2 }]}>작업 철수전 참고사항</Typography>
            </Grid>
            <Grid size={12}>
              <Typography sx={[styles1.Typography3, { marginTop: 1, marginLeft: 4 }]}>1.성함을 입력해주세요</Typography>
              <Typography sx={[styles1.Typography3, { marginTop: 1, marginLeft: 4 }]}>
                2.조회된 작업중 완료한 직업을 선택해주세요
              </Typography>
              <Typography sx={[styles1.Typography3, { marginTop: 1, marginLeft: 4 }]}>
                3.작업 철수 버튼을 누르고 장비를 반납해주세요
              </Typography>
            </Grid>
            <Grid size={12}></Grid>
          </Grid>
        </Grid>
        {/* <Grid size={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 5 }}>
          <Typography sx={styles1.Typography1}>작업목록</Typography>
        </Grid> */}
        <Grid size={12} sx={{ marginTop: 5 }}>
          {' '}
          <Box>
            <Grid container sx={{ marginBottom: 2 }}>
              <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                {/* <Typography>검색</Typography> */}
              </Grid>
              <Grid size={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Typography sx={styles1.Typography1}>조회결과</Typography>
              </Grid>

              <Grid size={12} sx={{ marginTop: 3 }}>
                {/* datatable */}
                {loadingFlag === true ? (
                  <Loader />
                ) : (
                  <>
                    <MantineReactTable table={table} />
                  </>
                )}
              </Grid>
              <Grid
                size={12}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 1 }}
              ></Grid>
              <Grid size={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    marginTop: 2,
                    background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                  }}
                  onClick={() => workOut()}
                >
                  작업 철수
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </div>
  )
}
